function generateSetID(s) {
  return s.replace(/[\W_]+/g, " ");
}

export class SetFilterUI {
  /**
   *
   * @param element
   * @param title
   * @param options
   * @param unsorted
   */
  constructor(element, title, options = new Set(), unsorted = false) {
    this.element = element;

    /**
     * The template function for the control
     * @type {function}
     */
    this.htmlTemplate = require("./views/setfilter.handlebars");

    this.idBase = `${element.attr("id")}_item`;
    this.title = title;
    this._options = options;
    this._excludedOptions = new Set();
    this._minPrices = [];
    this.onChange = function () {};
    this.unsorted = unsorted;
    this.update();
  }

  update() {
    const options = [];
    const obj = { title: this.title, options: options };
    const that = this;
    this._options.forEach((v, v2, s) => {
      options.push({
        set: !that._excludedOptions.has(v),
        id: that.idBase + generateSetID(v),
        text: that._prettyNames ? that._prettyNames[v] || v : v,
        code: v,
        minPrice: that._minPrices ? that._minPrices[v] : null,
      });
    });
    this.optionObjects = options;
    if (!this.unsorted) options.sort((a, b) => a.text.localeCompare(b.text));
    this.element.html(this.htmlTemplate(obj));
    this.optionObjects.forEach((v, i, a) => {
      v.element = $(`#${v.id}`);
      v.element.change(() => {
        if (!v.element.is(":checked")) {
          that._excludedOptions.add(v.code);
        } else {
          that._excludedOptions.delete(v.code);
        }
        that.handleInteraction();
      });
    });
    this.element.find("#inc-all").click(() => {
      that.includeAll();
    });
    this.element.find("#exc-all").click(() => {
      that.excludeAll();
    });
  }

  setValues(options, selectedOptions, minPrice = null, update = true) {
    this._options = options;
    this._excludedOptions = selectedOptions;
    this._minPrices = minPrice;
    if (update) {
      this.update();
    }
  }

  excludeAll() {
    for (let n of this.optionObjects) {
      this._excludedOptions.add(n.code);
    }
    this.update();
    this.handleInteraction();
  }

  includeAll() {
    this._excludedOptions.clear();
    this.update();
    this.handleInteraction();
  }

  addPrettyNames(names) {
    if (!this._prettyNames) this._prettyNames = {};
    for (let n in names) {
      if (names.hasOwnProperty(n)) this._prettyNames[n] = names[n];
    }
    this.update();
  }

  set selectedOptions(value) {
    this._excludedOptions = value;
    for (let n of this.optionObjects) {
      n.element.prop("checked", !value.has(n.code));
    }
  }

  get selectedOptions() {
    return this._excludedOptions;
  }

  set options(value) {
    this._options = value;
    this.update();
  }

  get options() {
    return this._options;
  }

  set minPrices(value) {
    this._minPrices = value;
    this.update();
  }

  get minPrices() {
    return this._minPrices;
  }

  handleInteraction(bubble = true) {
    this.onChange();
  }
}
